import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericService } from '../services/generic.service';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  userDetails: any;
  userName: any = '';
  userEmail: any = '';
  userId: any = '';
  userImage: any = '';
  userType: any = ""
  userCred: any = [];
  display_admin_or_customer_menus = "admin"
  menus: any = [];

  customerMenus: any = [
    {
      title: "Profile Info",
      icon: 'bi bi-folder-fill',
      children: [],
      arrow: 'bi bi-chevron-left',
      isOpen: 'subMenuClose',
      link: 'customer-profile'
    },
    {
      title: "My Plans",
      icon: 'bi bi-folder-fill',
      children: [],
      arrow: 'bi bi-chevron-left',
      isOpen: 'subMenuClose',
      link: 'customer-plans'
    },
    {
      title: "Invoice Info",
      icon: 'bi bi-folder-fill',
      children: [],
      arrow: 'bi bi-chevron-left',
      isOpen: 'subMenuClose',
      link: 'cust-invoice'
    },
    {
      title: "Paid Invoice Info",
      icon: 'bi bi-folder-fill',
      children: [],
      arrow: 'bi bi-chevron-left',
      isOpen: 'subMenuClose',
      link: 'cust-paid-invoice'
    },
    {
      title: "Tickets Info",
      icon: 'bi bi-folder-fill',
      children: [],
      arrow: 'bi bi-chevron-left',
      isOpen: 'subMenuClose',
      link: 'customer-tickets'
    },
  ]
  customerMobile: any = ""
  customerId: any = ""
  userData: any = [];

  menuToggle = false

  constructor(private router: Router, private route: ActivatedRoute, private generic_service: GenericService, private scroller: ViewportScroller) {
    this.generic_service.menuToggle.subscribe((value) => {
      this.menuToggle = Boolean(value)
    });
  }

  ngOnInit(): void {
    if (window.innerWidth <= 768) {
      this.generic_service.menuToggle.next(true);
    }
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);
    var splitted = location.href.split("/");

    this.customerMobile = splitted[splitted.length - 2];
    this.customerId = splitted[splitted.length - 1];
    let activeUrl = location.pathname.split("/");

    this.scrollToDiv(activeUrl[activeUrl.length - 1]);
    this.buildMenus();

    this.generic_service.menuRefresh.subscribe(() => {
      this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);
      this.buildMenus();
    });

    if (sessionStorage.getItem("token") == null || sessionStorage.getItem("token") == "" || sessionStorage.getItem("token") == undefined) {
      this.router.navigateByUrl('/login')
    } else {
      this.userEmail = sessionStorage.getItem("userEmail");
      this.userName = sessionStorage.getItem("userName");
      this.userId = sessionStorage.getItem("userId");
      this.userImage = sessionStorage.getItem("imageURL")
    }



    this.generic_service.menusType.subscribe((response) => {
      if (response == "admin") {
        this.display_admin_or_customer_menus = "admin";
      } else {
        this.display_admin_or_customer_menus = "customer";
        this.getCustomerByMobile(this.customerMobile)
      }
    });

    let isMenus = sessionStorage.getItem("menusType");
    if (isMenus && isMenus == "customer") {
      this.display_admin_or_customer_menus = "customer";
      this.getCustomerByMobile(this.customerMobile)
    } else {
      this.display_admin_or_customer_menus = "admin";
    }

    setTimeout(() => {
      if (activeUrl[activeUrl.length - 1] == "dash-board") {
        console.log(activeUrl[activeUrl.length - 1])
        let menu3 = document.getElementById("dashboard-route")
        menu3?.classList.add('background-color')
        menu3?.classList.add('active-color')
      }

    }, 500);

  }

  buildMenus() {
    let menus: any = [];
    let activeUrl = location.pathname.split("/");

    if (this.userCred?.isFavouriteList) {
      let allFavScreens: any[] = [];
      if (this.userCred?.favouriteList && Array.isArray(this.userCred.favouriteList)) {
        for (let item of this.userCred.favouriteList) {
          if (item.screenGroupList && Array.isArray(item.screenGroupList)) {
            for (let group of item.screenGroupList) {
              if (group.screenPrivilegeList && Array.isArray(group.screenPrivilegeList)) {
                allFavScreens.push(...group.screenPrivilegeList);
              }
            }
          } else if (item.screenPrivilegeList && Array.isArray(item.screenPrivilegeList)) {
            allFavScreens.push(...item.screenPrivilegeList);
          }
        }
      }

      // Filter unique screens
      let seen = new Set<string>();
      let uniqueScreens = allFavScreens.filter(screen => {
        let key = screen?.name || screen?.description;
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      let mainMenu: any = {
        title: "Favourite",
        icon: 'bi bi-caret-down-fill',
        children: [],
        arrow: 'bi bi-caret-down-fill',
        isOpen: '',
        isSelect: ''
      };

      for (var j = 0; j < uniqueScreens.length; j++) {
        let isSelect = '';

        if (uniqueScreens[j]?.name == activeUrl[activeUrl.length - 1]) {
          mainMenu.icon = 'bi bi-caret-down-fill';
          mainMenu.arrow = 'bi bi-caret-down-fill';
          mainMenu.isSelect = 'background-color';
          mainMenu.isOpen = '';
          isSelect = 'active-color1';
        }
        let subMenu: any = {
          icon: "bi bi-geo-alt",
          title: String(uniqueScreens[j]?.description || ''),
          link: String(uniqueScreens[j]?.name || "1h6lfzJ0wZw"),
          isSelect: isSelect
        };
        mainMenu.children.push(subMenu);
      }
      menus.push(mainMenu);
    } else {
      let rolePrevilages: any[] = this.userCred?.rolePrevilages || [];

      let isSubMenu = "subMenuClose";
      let isIcon = "bi bi-caret-right-fill";

      if (rolePrevilages && rolePrevilages.length < 3) {
        isSubMenu = "";
        isIcon = "bi bi-caret-down-fill";
      } else {
        isSubMenu = "subMenuClose";
        isIcon = "bi bi-caret-right-fill";
      }

      for (var i = 0; i < rolePrevilages.length; i++) {
        let screenList = rolePrevilages[i]?.screenPrivilegeList || [];
        let mainMenu: any = {
          title: String(rolePrevilages[i]?.groupName || ''),
          icon: isIcon,
          children: [],
          arrow: 'bi bi-caret-down-fill',
          isOpen: isSubMenu,
          isSelect: ''
        };
        for (var j = 0; j < screenList.length; j++) {
          let isSelect = '';

          if (screenList[j]?.name == activeUrl[activeUrl.length - 1]) {
            mainMenu.icon = 'bi bi-caret-down-fill';
            mainMenu.arrow = 'bi bi-caret-down-fill';
            mainMenu.isSelect = 'background-color';
            mainMenu.isOpen = '';
            isSelect = 'active-color1';
          }
          let subMenu: any = {
            icon: "bi bi-geo-alt",
            title: String(screenList[j]?.description || ''),
            link: String(screenList[j]?.name || "1h6lfzJ0wZw"),
            isSelect: isSelect
          };
          mainMenu.children.push(subMenu);
        }
        menus.push(mainMenu);
      }
    }
    this.menus = menus;
  }

  closeSidebar() {
    this.generic_service.menuToggle.next(true);
  }

  closeAllMenu() {
    for (let i = 0; i < this.menus.length; i++) {
      let subMenu = "subMenu" + i
      let arrow = "ar-r" + i
      let folder = "folder-r" + i
      let menu_r = "menu-r" + i
      let menu = document.getElementById(subMenu)
      let menuArrow = document.getElementById(arrow)
      let menuFolder = document.getElementById(folder)
      let menu_ = document.getElementById(menu_r)

      menu?.classList.add('subMenuClose')
      menuArrow?.classList.add('bi-chevron-left')
      menuArrow?.classList.remove('bi-chevron-down')
      menuFolder?.classList.add('bi-caret-right-fill')
      menuFolder?.classList.remove('bi-caret-down-fill')
      menu_?.classList.remove('background-color')
    }
  }

  dashboardSelect() {
    let menu = document.getElementById("dashboard-route")
    menu?.classList.add('background-color')
    menu?.classList.add('active-color')

    for (var j = 0; j < this.menus.length; j++) {
      for (var k = 0; k < this.menus[j].children.length; k++) {
        let menu_r = 'sub' + j + 'menu' + k
        let menu_ = document.getElementById(menu_r)
        menu_?.classList.remove('active-color')
        menu_?.classList.remove('active-color1')
      }
    }

    if (window.innerWidth <= 768) {
      this.generic_service.menuToggle.next(true);
    }
  }

  toggleMenu(index: any) {
    let subMenu = "subMenu" + index
    let arrow = "ar-r" + index
    let folder = "folder-r" + index
    let menu_r = "menu-r" + index


    let menu = document.getElementById(subMenu)
    let menuArrow = document.getElementById(arrow)
    let menuFolder = document.getElementById(folder)
    let menu_ = document.getElementById(menu_r)
    let activeUrl = location.pathname.split("/")
    // for(var j = 0; j < this.menus.length; j++) {
    //   let menu_r = "menu-r"+j
    //   let menu_ = document.getElementById(menu_r)
    //   menu_?.classList.remove('background-color')
    // }



    if (menu?.classList.contains('subMenuClose')) {
      menu.classList.remove('subMenuClose')
      // menuArrow?.classList.remove('bi bi-caret-right-fill')
      // menuArrow?.classList.add('bi bi-caret-down-fill')
      menuFolder?.classList.remove('bi-caret-right-fill')
      menuFolder?.classList.add('bi-caret-down-fill')
      menu_?.classList.add('background-color')

    } else {
      menu?.classList.add('subMenuClose')
      // menuArrow?.classList.add('bi-chevron-left')
      // menuArrow?.classList.remove('bi-chevron-down')
      menuFolder?.classList.add('bi-caret-right-fill')
      menuFolder?.classList.remove('bi-caret-down-fill')
      menu_?.classList.remove('background-color')
    }
  }

  routeLink(link: any, parentTitle?: string) {
    if (parentTitle) {
      sessionStorage.setItem('activeBreadcrumbParent', parentTitle);
    }
    for (var j = 0; j < this.menus.length; j++) {
      for (var k = 0; k < this.menus[j].children.length; k++) {
        if (this.menus[j].children[k].link == link) {
          let menu_r = 'sub' + j + 'menu' + k
          let menu_ = document.getElementById(menu_r)
          menu_?.classList.add('active-color')
          menu_?.classList.add('active-color1')
        } else {
          let menu_r = 'sub' + j + 'menu' + k
          let menu_ = document.getElementById(menu_r)
          menu_?.classList.remove('active-color')
          menu_?.classList.remove('active-color1')

        }
      }
    }
    // for(let route of routes){
    //   if(route == link){
    //     window.location.href = "admin/"+link
    //   }else{
    //     this.router.navigate([link], { relativeTo: this.route });
    //   }
    // }
    // this.router.navigateByUrl(link)
    let menu = document.getElementById("dashboard-route")
    menu?.classList.remove('background-color')
    menu?.classList.remove('active-color')
    this.router.navigate([link], { relativeTo: this.route });

    if (window.innerWidth <= 768) {
      this.generic_service.menuToggle.next(true);
    }
  }

  goToHomePage() {
    this.router.navigateByUrl('/home')
  }

  goToCustomer() {
    let url = 'admin/customer-info';
    this.generic_service.menusType.next('admin')
    sessionStorage.setItem('menusType', 'admin')
    this.router.navigate([url]);
  }

  getCustomerByMobile(customerMobile: any) {
    this.generic_service.getCustomerByMobile(customerMobile).subscribe(
      (response: any) => {
        this.userData = []
        this.userData.push(response.response)
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  goToLink(link: any) {
    var splitted = location.href.split("/");
    this.customerMobile = splitted[splitted.length - 2];
    this.customerId = splitted[splitted.length - 1];
    let url = 'admin/' + link + '/' + this.customerMobile + '/' + this.customerId;
    this.router.navigate([url]);

    if (window.innerWidth <= 768) {
      this.generic_service.menuToggle.next(true);
    }
  }

  scrollToTop(scroll2: any) {
    let folder = "folder-r" + scroll2
    let sc: any = document.getElementById(folder);
    sc.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest"
    })
  }

  scrollToDiv(targetDiv: any) {
    let div = '#' + targetDiv
    const element = document.querySelector(div);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }




  isDarkMode = true;

  onThemeToggle(isDark: boolean): void {
    this.isDarkMode = isDark;
    if (isDark) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }

}